import React from 'react';
import { LogisticNetwork, NetworkFile } from '@/types/data';

interface OverviewTabProps {
  currentNetwork: LogisticNetwork | null;
}

const OverviewTab: React.FC<OverviewTabProps> = ({ currentNetwork }) => {
  if (!currentNetwork) return null;

  return (
    <div>
      <div className="bg-primary-50 p-4 rounded-lg mb-4">
        <h3 className="text-xl font-medium text-primary-800 mb-2">{currentNetwork.name}</h3>
        <p className="text-gray-600">Network ID: {currentNetwork.id}</p>
        <p className="text-gray-600">Files: {currentNetwork.files.length}</p>
      </div>

      {currentNetwork.files.length ? (
        <div>
          <h4 className="text-lg font-medium text-primary-700 mb-2">Files in this network:</h4>
          <ul className="space-y-2 border border-gray-200 rounded-lg p-4">
            {currentNetwork.files.map((file: NetworkFile) => (
              <li key={file.id} className="flex items-center p-2 hover:bg-gray-50 rounded">
                <span className="text-gray-800">{file.name}</span>
                <span className="ml-2 text-xs text-gray-500">({file.type})</span>
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <p className="text-gray-600">No files have been added to this network yet.</p>
      )}
    </div>
  );
};

export default OverviewTab;
